<template>
  <div class="sjcj">
    <div class="card1">
      <div class="w1280">
        <div style="padding: 112px 0;">
          <div class="t11">互联网AI应用数据解决方案</div>
          <div class="t22">
            行业领先的标注平台和全面的数据服务，支持您的互联网AI数据需求
          </div>
          <div class="btn1" style="margin: 0 auto;" @click="go('/callMe')">咨询数据解决方案</div>
        </div>
      </div>
    </div>
    <div class="w1280" style="margin: 48px auto;">
      <div class="flexs">
        <div style="width: 48%;">
          <div class="title-1">全面支持您的互联网数据需求</div>
          <div class="title-2">提供全面的AI数据服务，包括数据采集、标注、测试、本地化、以及LLM相关数据服务，支持互联网企业的AI数据需求。</div>
          <ul>
            <li>超过 7 年的行业专业知识</li>
            <li>与全球领先的互联网公司合作</li>
            <li>在各类应用场景拥有深厚的专业知识，包括搜索相关性、个性化、内容审核、本地化等</li>
          </ul>
        </div>
        <div style="width: 48%;">
          <img style="width: 100%;border-radius:16px" src="../assets/img/sjfw/m1.webp" alt="">
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">应用场景：互联网AI</div>
      
      <div class="w1280" style="margin-top:48px">
        <div class="flexs" style="flex-wrap: wrap;">
          <div class="card-sx" v-for="(item, index) in cardList" :key="index">
            <img
              style="width: 405px;height: 192px;border-radius:8px 8px 0 0;object-fit: cover; object-position: top;"
              :src="item.img"
              alt=""
            />
            <div class="contents">
              <div class="t1">{{ item.title }}</div>
              <div
                v-for="(item1, index1) in item.textList"
                :key="index1"
                class="t2"
              >
                {{ item1.title }}<span class="t3">{{ item1.content }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card2">
      <div class="title">数据解决方案</div>
      <div class="slogan">提供全面的数据采集和标注服务，涵盖全球多个国家和地区以及多种语言，支持您的互联网AI数据需求。</div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 45%;">
            <div class="t1">数据采集定制服务</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>数字人采集</li>
                  <li>动作捕捉</li>
                  <li>多声线TTS采集</li>
                  <li>人脸采集</li>
                  <li>掌纹采集</li>
                  <li>虹膜采集</li>
                </ul>
              </div>
              <div style="width: 50%;">
                
              </div>
            </div>
            <div class="btn1" @click="go('/callMe')">
              咨询定制标注服务
              <i class="el-icon-right"></i>
            </div>
          </div>
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/dmx.webp"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="w1280" style="margin-bottom: 64px;">
        <div class="flexs">
          <div style="width: 50%;">
            <img
              style="width: 100%;margin: 50px 0;border-radius: 16px;"
              src="../assets/img/sjfw/y2.webp"
              alt=""
            />
          </div>
          <div style="width: 45%;">
            <div class="t1">数据标注定制服务</div>
            <div
              class="flexs"
              style="justify-content: left;margin-bottom: 48px;"
            >
              <div style="width: 50%;">
                <ul>
                  <li>内容审核</li>
                  <li>语音标注</li>
                  <li>文本生成</li>
                  <li>图生文</li>
                  <li>视频描述</li>
                  <li>翻译</li>
                  <li>游戏视频类标注</li>
                  <li>搜索相关性</li>
                </ul>
              </div>
              <div style="width: 50%;">
               
              </div>
            </div>
            <div class="btn1" @click="go('/callMe')">
              项目咨询
              <i class="el-icon-right"></i>
            </div>
          </div>
          
        </div>
      </div>
      
    </div>
    <div class="card2">
      <div class="title">我们的优势</div>
      <div class="w1280" style="">
        <div class="flexs" style="flex-wrap: wrap;margin:32px 128px">
          <div class="card-ys" v-for="(item, index) in ysList" :key="index">
            <img style="width:48px;height:48px;margin-bottom:8px" :src="item.img" alt="" />
            <div class="t1">{{item.name}}</div>
            <div class="t2">{{item.content}}</div>
          </div>
        </div>
      </div>
      </div>
    <div class="card-footer">
      <div class="t1">大规模数据采标能力</div>
      <div class="t2">为您的互联网AI数据需求提供高效解决方案</div>
      <div class="btns" @click="go('/callMe')">联系我们</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ysList:[
        {
          name: "一站式数据管理",
          content:
            "我们已经成功交付多种类互联网AI数据项目，提供采集、数据清洗、数据标注、模型测试的一站式数据管理服务。",
          img: require("../assets/img/sjfw/e1.svg"),
        },
        {
          name: "全球团队",
          content:
            "在海内外拥有众多众包，同时在海外也有自有标注基地，为您的出海项目提供全面支持。",
          img: require("../assets/img/sjfw/e2.svg"),
        },
        {
          name: "质量交付",
          content:
            "我们的高质量要求已经服务过数百个项目并维持99%的平均初始数据通过率，为您提供高质量数据服务。",
          img: require("../assets/img/sjfw/e3.svg"),
        },
        {
          name: "数据安全",
          content:
            "通过了ISO27001,ISO9001与ISO27701，以及EHS证书，同时搭建了多个合规室/安全屋，同时有1000+内部标注员为您的高安全要求提供支持。",
          img: require("../assets/img/sjfw/e4.svg"),
        },],
      cardList1: [
        {
          name: "数据存储与传输",
          list:[{t:'国安级加密云技术保证数据传输和存储安全'},{t:'业界领先的Appen Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别'}],
          img: require("../assets/img/sjfw/x1.svg"),
        },
        {
          name: "项目现场与监管",
         list:[{t:'项目现场配置人脸识别和指纹门禁'},{t:'设有加密项目房间，仅授权人员准许进入 Secure Workspace可确保在家办公环境达到与安全设备相同的安全级别'},{t:'配有24*7值班人员以及无死角摄像头监控现场'}],
          img: require("../assets/img/sjfw/x2.svg"),
        },
        {
          name: "雇员与被采人管控",
          list:[{t:'标注人员及供应商签署保密协议'},{t:'全体员工办公设备均统一管理'}],
          img: require("../assets/img/sjfw/x3.svg"),
        }
      ],
      cardList: [
        {
          title: "虚拟数字人",
          img: require("../assets/img/sjfw/b1.webp"),
          textList: [
            {
              title: "",
              content: "虚拟数字人在AI的辅助下越发逼真、快速、便捷，逐渐应用在视频制作、直播、新闻播报、互动交流、游戏制作等多领域，满足了娱乐、新闻、文旅、金融等多场景的需要。其中，虚拟图像驱动以及语音合成等仍需要大量数据支持。",
            }
          ],
        },
        {
          title: "内容审核",
          img: require("../assets/img/sjfw/b2.webp"),
          textList: [
            {
              title: "",
              content: "随着新媒体时代内容数量井喷，违规内容层出不穷且与日俱增；相关政策不断出台，规则日渐复杂；企业相关的正负面讨论也需监控，内容审核成为了互联网企业重要的一部分。AI支持的内容审核配合人力团队的支持，也成为新的趋势。",
            },
           
          ],
        },
        {
          title: "AR/VR",
          img: require("../assets/img/sjfw/b3.webp"),
          textList: [
            {
              title: "",
              content:
                "AR换装、换“妆”、AR红包、AR导航……AR已经深入众多APP，提供娱乐与便捷。同时，VR眼镜、VR游戏等产品也成为新兴产品。AR和VR离不开AI，提供包括环境识别、位置定位、动作捕捉等程序支持。",
            },
          ],
        },
        {
          title: "动画与游戏",
          img: require("../assets/img/sjfw/b4.webp"),
          textList: [
            {
              title: "",
              content:
                "AI在游戏与动画的场景构建、角色设计与动作捕捉等方面有极大的潜力，可以快速生成相关素材与场景。不仅使动画制作的过程变得更加高效和灵活，同时也为动画师提供了更多的创作空间和灵感。",
            },
            
          ],
        },
        {
          title: "身份认证",
          img: require("../assets/img/sjfw/b5.webp"),
          textList: [
            {
              title: "",
              content:
                "人脸认证已经是很普遍的身份认证方法，包括人脸支付、政企应用等。现在，虹膜识别与掌纹识别等新型认证方法也正在普及，需要更多的数据来支持准确与高效的识别。",
            },
            
          ],
        },
        {
          title: "配音生成",
          img: require("../assets/img/sjfw/b6.webp"),
          textList: [
            {
              title: "",
              content:
                "语音合成现已广泛使用在语音助手，客服助理，出行导航，阅读听书，短视频实时配音制作，游戏配音等应用中，并对音色、仿真、情感等方面提出了更高的要求，需要更加丰富多元化的数据支持。",
            },
            
          ],
        },
      ],
    };
  },
  methods: {
    go(path) {
      this.$router.push(path);
    }
  },
};
</script>
<style lang="scss" scoped>
.sjcj {
  .card1 {
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    width: 100%;
    height: 450px;
  }
  .card4 {
    width: 1280px;
    margin: 48px auto;
    text-align: center;
    .item-card2{
      flex-shrink: 0;
      text-align: center;
      width: 340px;
      margin: 40px 30px ;
    }
    .item-card {
      height: 240px;
      flex-shrink: 0;
      padding: 40px 24px;
      background-color: #eceff0;
      border-radius: 8px;
      width: 360px;
      margin-top: 20px;
      text-align: left;
      font-size: 16px;
    }
    .select-tab {
      margin: 30px 0 20px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      height: 38px;
      line-height: 38px;
      align-content: center;
      padding: 2px;
      border-radius: 25px;
      border-width: 1px;
      border-style: solid;
      border-color: #000;
      border-image: initial;
      .s-tabs {
        width: 20%;
        height: 38px;
        text-align: center;
        cursor: pointer;
        border-radius: 25px;
      }
      .is-active {
        color: rgb(255, 255, 255);
        background: #045588;
      }
    }
    .card4-t1 {
      color: #045588;
      font-size: 48px;
      font-weight: bold;
    }
    .card4-t2 {
      font-size: 16px;
      width: 680px;
      margin: 24px auto 0;
      line-height: 1.5;
    }
    .card4-t3 {
      font-size: 32px;
      text-align: left;
      margin-bottom: 56px;
      color: #045588;
      font-weight: bold;
    }
    .btns {
      cursor: pointer;
      margin-top: 32px;
      width: 150px;
      background-color: #099fee;
      color: #fff;
      height: 48px;
      line-height: 48px;
      padding: 0 20px;
      border-radius: 8px;
    }
  }
  .card2 {
    width: 1280px;
    margin: 0 auto;
    .card-ys{
      width:448px;
      height:178px;
      padding: 24px;
      background-color: #eceff0;
      border-radius: 8px;
      margin-top:24px;
      .t1{
        font-size:20px;
        color: #25282a;
        margin-bottom: 16px;
      }.t2{
        font-size:16px;
        color: #25282a;
      }
    }
    .card-sx {
      width: 405px;

      margin: 0 0 48px;
      .contents {
        padding: 24px;
        height: 228px;
        background-color: #eceff0;
        border-radius: 0 0 8px 8px;
        .t1 {
          color: #045588;
          font-size: 24px;
          font-weight: 500;
          margin-bottom: 32px;
        }
        .t2 {
          color: #4b4f54;
          font-weight: bold;
          font-size: 16px;
          line-height: 1.5;
        }
        .t3 {
          font-weight: normal;
        }
      }
    }
    li {
      line-height: 1.5;
    }
    .t1 {
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
      font-weight: 500;
    }
    .title {
      color: #045588;
      text-align: center;
      margin-top: 64px;
      font-weight: 500;
      font-size: 48px;
      margin-bottom: 8px;
    }
    .slogan {
      color: rgb(75, 79, 84);
      font-size: 16px;
      text-align: center;
      line-height: 1.2;
      width: 768px;
      margin: 0 auto 64px;
    }
  }
  .card-footer {
    width: 100%;
    height: 328px;
    background-image: linear-gradient(72deg, #7cd0ff54 7.43%, #f0efea 88.33%);
    .t1 {
      color: rgb(0, 126, 204);
      font-weight: 500;
      font-size: 50px;
      text-align: center;
      padding-top: 60px;
    }
    .t2 {
      text-align: center;
      margin-top: 24px;
    }
    .btns {
      cursor: pointer;
      text-align: center;
      background-image: linear-gradient(
        260.38deg,
        #099fee 3.89%,
        #2247da 143.13%
      );
      width: 96px;
      height: 48px;
      padding: 0 16px;
      line-height: 48px;
      color: #fff;
      margin: 24px auto 0;
      border-radius: 8px;
    }
  }
  .btn1 {
    cursor: pointer;
    width: 250px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #fff;
    background-color: #099fee;
    border-radius: 8px;
  }
  .w1280 {
    width: 1280px;
    margin: 0 auto;
    .t11 {
      color: #045588;
      font-size: 56px;
      font-weight: bold;
      line-height: 84px;
      text-align: center;
    }
    .t22 {
      margin: 32px 256px;
      text-align: center;
      font-size: 20px;
      color: #4b4f54bf;
    }
    .title-1{
      color: #045588;
      font-size: 32px;
      margin-bottom: 16px;
    }
    .title-2{
      font-size:16px;
      line-height: 1.5;
    }
    li{
      margin-left: 24px;
      line-height: 1.5;
    }
  }
  .flexs {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
<style></style>
